export default "__VITE_ASSET__CkqHJY0W__"